module.exports = __webpack_public_path__ + "img/background13.f7cab94b.jpg";